<div class="title-bar">
	<nav aria-label="breadcrumb">
		<ol class="breadcrumb">
			<li class="breadcrumb-item active" aria-current="page">
				<fa-icon [icon]="ac.sectionIcons.files" class="cp-admin-nav-item me-1" size="sm">
				</fa-icon>
				Files
			</li>
		</ol>
	</nav>

	<div class="actions">
		<div class="form-inline">
			<button *ngIf="canAdd" type="button" class="btn btn-outline-primary me-2" routerLink="new">
				<fa-icon [icon]="['fas', 'cloud-upload-alt']" size="sm"></fa-icon>
				<span class="cp-action-button-text">Upload Files</span>
			</button>

			<button type="button" class="btn btn-outline-secondary" (click)="refresh()">
				<fa-icon icon="sync-alt" size="sm" [spin]="refreshing" ngbTooltip="Refresh" placement="start"></fa-icon>
				<!-- <span class="cp-action-button-text">Refresh</span> -->
			</button>
		</div>
	</div>
</div>

<div *ngIf="loading || refreshing" style="text-align: center;">
	<app-loading-spinner></app-loading-spinner>
</div>

<button (click)="ut.scrollToSpot('top-of-list')" id="top-of-list-button" class="cp-scroll-to-top-end d-none" title="Go to top">
	<fa-icon [icon]="['fas', 'angle-up']"></fa-icon>Top
</button>
<div class="list-wrapper" id="list-page-id" (scroll)="ut.onDivScrollHandler('top-of-list-button', 'list-page-id')">
	<div id="top-of-list"></div>
	<app-paging-search-bar [parentApi]="getParentMethod()" [centered]="false"></app-paging-search-bar>

	<table *ngIf="!loading && itemsToShow.length > 0" class="cp-std-table cp-auto-width">
		<thead>
			<tr app-column-headings [parentApi]="getParentMethod()" [columnDefs]="columnDefs" [fieldsToShow]="fieldsToShow"
				[displayOptions]="displayOptions">
			</tr>
		</thead>
		<tbody *ngIf="itemsToShow && !loading">
			<tr *ngFor="let item of itemsToShow">
				<td class="cp-chopped-col-long"><a [routerLink]="[item.id]" [ngbTooltip]="item.name">{{ item.name }}</a></td>
				<td>{{ item.free_access_token }}</td>
				<td class="text-center" [attr.data-order]="item.uses.join('; ')">
					<fa-icon *ngIf="item.uses.length > 0" [icon]="['fas', 'check']" size="sm" [ngbTooltip]="item.uses.join('; ')">
					</fa-icon>
				</td>
				<td class="text-nowrap text-end" [attr.data-order]="item.size">
					{{ item.size | bytes: "1.0-0" }}
				</td>
				<td class="text-nowrap text-end" [attr.data-order]="item.downloads">
					{{ tt.formatCount(item.downloads) }}
				</td>
				<td class="text-center text-nowrap">
					<div *ngIf="item.added_on" [ngbTooltip]="item.added_on | date: ac.shortPageDateTimeFmt">
						{{ item.added_on | timeback }}
					</div>
				</td>
				<td class="text-center text-nowrap">
					<div *ngIf="item.last_download" [ngbTooltip]="item.last_download | date: ac.shortPageDateTimeFmt">
						{{ item.last_download | timeback }}
					</div>
				</td>
			</tr>
		</tbody>
	</table>
	<app-paging-bar [parentApi]="getParentMethod()" [pageNum]="displayOptions.pageNum" [pagingOptions]="pagingOptions"
		[centered]="false"></app-paging-bar>
</div>